
import React from 'react';
import { lazyWithPreload } from "react-lazy-with-preload";
const Route0 = lazyWithPreload(() => import('/home/runner/work/react-trace/react-trace/apps/website/docs/extending/plugin-api.mdx'))
const Route1 = lazyWithPreload(() => import('/home/runner/work/react-trace/react-trace/apps/website/docs/extending/ui-components.mdx'))
const Route2 = lazyWithPreload(() => import('/home/runner/work/react-trace/react-trace/apps/website/docs/guide/configuration.mdx'))
const Route3 = lazyWithPreload(() => import('/home/runner/work/react-trace/react-trace/apps/website/docs/guide/index.mdx'))
const Route4 = lazyWithPreload(() => import('/home/runner/work/react-trace/react-trace/apps/website/docs/guide/installation.mdx'))
const Route5 = lazyWithPreload(() => import('/home/runner/work/react-trace/react-trace/apps/website/docs/guide/production-stubs.mdx'))
const Route6 = lazyWithPreload(() => import('/home/runner/work/react-trace/react-trace/apps/website/docs/index.mdx'))
const Route7 = lazyWithPreload(() => import('/home/runner/work/react-trace/react-trace/apps/website/docs/plugins/comments.mdx'))
const Route8 = lazyWithPreload(() => import('/home/runner/work/react-trace/react-trace/apps/website/docs/plugins/copy-to-clipboard.mdx'))
const Route9 = lazyWithPreload(() => import('/home/runner/work/react-trace/react-trace/apps/website/docs/plugins/index.mdx'))
const Route10 = lazyWithPreload(() => import('/home/runner/work/react-trace/react-trace/apps/website/docs/plugins/open-editor.mdx'))
const Route11 = lazyWithPreload(() => import('/home/runner/work/react-trace/react-trace/apps/website/docs/plugins/preview.mdx'))
export const routes = [
{ path: '/extending/plugin-api', element: React.createElement(Route0), filePath: 'extending/plugin-api.mdx', preload: async () => {
        await Route0.preload();
        return import("/home/runner/work/react-trace/react-trace/apps/website/docs/extending/plugin-api.mdx");
      }, lang: 'en', version: '' },
{ path: '/extending/ui-components', element: React.createElement(Route1), filePath: 'extending/ui-components.mdx', preload: async () => {
        await Route1.preload();
        return import("/home/runner/work/react-trace/react-trace/apps/website/docs/extending/ui-components.mdx");
      }, lang: 'en', version: '' },
{ path: '/guide/configuration', element: React.createElement(Route2), filePath: 'guide/configuration.mdx', preload: async () => {
        await Route2.preload();
        return import("/home/runner/work/react-trace/react-trace/apps/website/docs/guide/configuration.mdx");
      }, lang: 'en', version: '' },
{ path: '/guide/', element: React.createElement(Route3), filePath: 'guide/index.mdx', preload: async () => {
        await Route3.preload();
        return import("/home/runner/work/react-trace/react-trace/apps/website/docs/guide/index.mdx");
      }, lang: 'en', version: '' },
{ path: '/guide/installation', element: React.createElement(Route4), filePath: 'guide/installation.mdx', preload: async () => {
        await Route4.preload();
        return import("/home/runner/work/react-trace/react-trace/apps/website/docs/guide/installation.mdx");
      }, lang: 'en', version: '' },
{ path: '/guide/production-stubs', element: React.createElement(Route5), filePath: 'guide/production-stubs.mdx', preload: async () => {
        await Route5.preload();
        return import("/home/runner/work/react-trace/react-trace/apps/website/docs/guide/production-stubs.mdx");
      }, lang: 'en', version: '' },
{ path: '/', element: React.createElement(Route6), filePath: 'index.mdx', preload: async () => {
        await Route6.preload();
        return import("/home/runner/work/react-trace/react-trace/apps/website/docs/index.mdx");
      }, lang: 'en', version: '' },
{ path: '/plugins/comments', element: React.createElement(Route7), filePath: 'plugins/comments.mdx', preload: async () => {
        await Route7.preload();
        return import("/home/runner/work/react-trace/react-trace/apps/website/docs/plugins/comments.mdx");
      }, lang: 'en', version: '' },
{ path: '/plugins/copy-to-clipboard', element: React.createElement(Route8), filePath: 'plugins/copy-to-clipboard.mdx', preload: async () => {
        await Route8.preload();
        return import("/home/runner/work/react-trace/react-trace/apps/website/docs/plugins/copy-to-clipboard.mdx");
      }, lang: 'en', version: '' },
{ path: '/plugins/', element: React.createElement(Route9), filePath: 'plugins/index.mdx', preload: async () => {
        await Route9.preload();
        return import("/home/runner/work/react-trace/react-trace/apps/website/docs/plugins/index.mdx");
      }, lang: 'en', version: '' },
{ path: '/plugins/open-editor', element: React.createElement(Route10), filePath: 'plugins/open-editor.mdx', preload: async () => {
        await Route10.preload();
        return import("/home/runner/work/react-trace/react-trace/apps/website/docs/plugins/open-editor.mdx");
      }, lang: 'en', version: '' },
{ path: '/plugins/preview', element: React.createElement(Route11), filePath: 'plugins/preview.mdx', preload: async () => {
        await Route11.preload();
        return import("/home/runner/work/react-trace/react-trace/apps/website/docs/plugins/preview.mdx");
      }, lang: 'en', version: '' }
];
